module.exports = __webpack_public_path__ + "static/media/reportes.c5700fb7.png";